import { Divider, Grid, Group, Skeleton } from '@mantine/core';
import React from 'react';
import XSkeleton1Fields from '../../../../components/x-components/x-skeletons/x-skeleton-1-fields.component';

function SkeletonUpdatePOSPage(props: Props) {
  const { skeletonHeight, skeletonWidth } = props;
  const height = skeletonHeight ?? 14;
  const width = skeletonWidth ?? '100%';
  return (
    <>
      <Grid>
        <XSkeleton1Fields
          skeletonHeight={height}
          skeletonWidth={width}
          skeletonXS={6}
        />
      </Grid>
    </>
  );
}

interface Props {
  skeletonHeight?: number;
  skeletonWidth?: number | string;
}

export default SkeletonUpdatePOSPage;
